import React from "react";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import AddItems from "../Registration/Items/addItems";
import AltItems from "../Registration/Items/altItems";
import BottomBar from "../../Components/bottomBar/bottomBar";
import "./prelude.css";
import Api from "../../services/api";
import TableList from "../../Components/tableList/TableList";
import Alert from "../../Components/alert/Alert";
import MessageTable from "../../Components/messageTable/MessageTable";
import TopBar from "../../Components/topBar/topBar";
import { handleColor } from "../../services/Functions";
import ReportItems from "../Reports/reportItems";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";

const prelude_items = () => {
  const [activeTab, setActiveTab] = React.useState("list");
  return (
    <>
      <header>
        <TopBar />
      </header>
      <main className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </main>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = {
    data: [],
    keys: [],
    render: false,
    message: "",
    click: false,
    controller: "",
    id: "",
    redirect: false,
    operations: [],
  };

  async componentDidMount() {
    let array = [];
    let array1 = [];
    await Api.get("/items")
      .then((response) => {
        response.data.forEach((element) => {
          array.push({
            Código: element.code,
            descrição: element.description,
          });
        });
        if (array.length > 0)
          this.setState({ data: array, operations: array1, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
    /*  let viewport = document.querySelector("meta[name=viewport]");
      viewport.setAttribute("content", viewport.content + ", height=" + window.innerHeight); */
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message } = this.state;
    const items = [
      { id: "lg1", label: "Itens", eventKey: "list" },
      { id: "lg2", label: "Adicionar Item", eventKey: "add" },
      { id: "lg3", label: "Alterar / excluir Item", eventKey: "alt" },
    ];
    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1">
            <div
              className={this.props.isMobile ? "sidebar2-mobile" : "sidebar2"}
            >
              <Col className="sidebarColumn" mountOnEnter unmountOnExit>
                <ListGroup>
                  {items.map((item) =>
                    this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            this.props.handleClose();
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    )
                  )}
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "2%",
                marginLeft: "1%",
                width: "100%",
                height: "96%",
                overflow: "hidden",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              {!this.props.isMobile && (
                <Tab.Content style={{ height: "100%" }}>
                  <Tab.Pane style={{ height: "100%" }} eventKey="list">
                    {this.handleClick ? <ReportItems /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    style={{
                      height: "100%",
                      overflow: "auto",
                      overflowX: "hidden",
                    }}
                    eventKey="add"
                  >
                    {this.handleClick ? <AddItems /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    className="display"
                    style={{
                      height: "100%",
                      overflow: "auto",
                      overflowX: "hidden",
                    }}
                    eventKey="alt"
                  >
                    {this.handleClick ? <AltItems /> : null}
                  </Tab.Pane>
                </Tab.Content>
              )}
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_items;
